import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { List, X } from "@phosphor-icons/react";

// SEGURIDAD: Extraemos con valores de respaldo (Fallback) para que nunca se rompa el link
const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || "522282425769";
const WHATSAPP_MSG = process.env.REACT_APP_WHATSAPP_MSG_HERO || "Hola, me gustaría cotizar un servicio para mi equipo.";

const Header = () => {
    const [open, setOpen] = useState(false);
    const [hidden, setHidden] = useState(false);

    const navigate = useNavigate();

    const navItems = [
        { name: "Inicio", id: "inicio" },
        { name: "Quiénes Somos", id: "sobre-nosotros" },
        { name: "Servicios", id: "servicios" },
        { name: "Catálogo", id: "/catalogo" },
        { name: "Contacto", id: "contacto" }
    ];

    const goToSection = (sectionId) => {
        setOpen(false);
        if (window.location.pathname !== "/") {
            navigate("/");
            setTimeout(() => {
                const el = document.getElementById(sectionId);
                if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
            }, 300);
        } else {
            const el = document.getElementById(sectionId);
            if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };

    // Generamos el link de WhatsApp de forma segura una sola vez
    const whatsappLink = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MSG)}`;

    useEffect(() => {
        let lastScroll = window.scrollY;
        const handleScroll = () => {
            const current = window.scrollY;
            if (current > lastScroll && current > 80) {
                setHidden(true);
            } else {
                setHidden(false);
            }
            lastScroll = current;
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <header
            className={`fixed top-0 w-full z-50 bg-[#12223D] shadow-lg transition-transform duration-300 ${
                hidden ? "-translate-y-full" : "translate-y-0"
            }`}
        >
            <div className="container mx-auto px-4 py-2 flex items-center justify-between">
                <Link to="/" className="flex items-center">
                    <img
                        src="/LogoCTEX.webp"
                        alt="CTEX Logotipo"
                        className="h-12 md:h-14 w-auto object-contain transition-transform duration-300 hover:scale-105"
                        onError={(e) => { e.target.style.display = 'none'; e.target.after('CTEX'); }}
                    />
                </Link>

                <nav className="hidden md:block">
                    <ul className="flex items-center gap-8">
                        {navItems.map(item => (
                            <li key={item.id}>
                                {item.id.startsWith('/') ? (
                                    <Link to={item.id} className="text-white font-medium hover:text-ctex-orange transition-colors">
                                        {item.name}
                                    </Link>
                                ) : (
                                    <button
                                        onClick={() => goToSection(item.id)}
                                        className="text-white font-medium hover:text-ctex-orange transition-colors"
                                    >
                                        {item.name}
                                    </button>
                                )}
                            </li>
                        ))}
                    </ul>
                </nav>

                <div className="hidden md:flex items-center gap-4">
                    <a
                        href={whatsappLink}
                        target="_blank"
                        rel="noopener noreferrer" // PROTECCIÓN: Tabnabbing en desktop
                        className="bg-ctex-orange text-white font-bold py-2 px-6 rounded-full shadow-lg hover:bg-orange-600 transition-all hover:-translate-y-0.5 text-sm"
                    >
                        💬 Solicitar Servicio
                    </a>
                </div>

                <button
                    className="md:hidden p-2 text-white hover:bg-white/10 rounded-lg transition-colors"
                    onClick={() => setOpen(v => !v)}
                >
                    {open ? <X size={28} /> : <List size={28} />}
                </button>
            </div>

            {open && (
                <div className="md:hidden bg-[#12223D] border-t border-white/10 shadow-2xl">
                    <div className="px-4 py-6 flex flex-col gap-2">
                        {navItems.map(item => (
                            <li key={item.id} className="list-none">
                                {item.id.startsWith('/') ? (
                                    <Link
                                        to={item.id}
                                        onClick={() => setOpen(false)}
                                        className="block text-white py-3 px-4 rounded-xl hover:bg-white/5 font-medium"
                                    >
                                        {item.name}
                                    </Link>
                                ) : (
                                    <button
                                        onClick={() => goToSection(item.id)}
                                        className="w-full text-left text-white py-3 px-4 rounded-xl hover:bg-white/5 font-medium"
                                    >
                                        {item.name}
                                    </button>
                                )}
                            </li>
                        ))}
                        <a
                            href={whatsappLink}
                            className="mt-4 text-center bg-ctex-orange text-white font-bold py-4 rounded-2xl shadow-xl"
                            target="_blank"
                            rel="noopener noreferrer" // PROTECCIÓN: Tabnabbing en móvil
                        >
                            💬 Solicitar Servicio
                        </a>
                    </div>
                </div>
            )}
        </header>
    );
};

export default Header;
